import React from 'react';
import { arrangeTiles } from '../../helpers/dom';
import './scroller.css';

export class Scroller extends React.Component {
	constructor(props) {
		super(props);

		this.scroller = null;

		this.scroll = this.scroll.bind(this);
		this.forceResize = this.forceResize.bind(this);
	}

	scroll(direction) {
		const localWidth = this.cardWidth;
		const node = this.scroller;
		const final = node.scrollLeft + (direction === 1 ? localWidth : -1 * localWidth);

		const scrollABit = to => {
			if ((direction === 1 && to < final) || (direction !== 1 && to > final)) {
				node.scrollLeft = to;
				setTimeout(() => {
					scrollABit(to + direction * 10);
					this.forceUpdate();
				}, 1);
			}
		};

		scrollABit(node.scrollLeft);
	}

	componentDidUpdate() {
		const { childClassName } = this.props;

		const cards = this.scroller.getElementsByClassName(childClassName);
		if (typeof cards === 'object' && cards.length > 0) {
			const card = cards[0];
			this.cardWidth = card.clientWidth + 22;
		}

		setTimeout(() => {
			this.props.setHeights && arrangeTiles(childClassName, this.scroller);
		}, 250);
	}

	forceResize() {
		this.scroller.scrollLeft = 0;
		this.forceUpdate();
	}

	componentDidMount() {
		this.forceResize();
		window.addEventListener('resize', this.forceResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.forceResize);
	}

	render() {
		const { children, hideButtonsIfNotRequired, suppress, hideFreeze } = this.props;

		const freezeRight =
			this.scroller && Math.ceil(this.scroller.scrollLeft) + this.scroller.clientWidth >= this.scroller.scrollWidth;
		const freezeLeft = this.scroller && this.scroller.scrollLeft === 0;

		const hide = suppress || (hideButtonsIfNotRequired && freezeLeft && freezeRight);

		return (
			<div className="scroll-container">
				{!hide && (
					<div className="left">
						{!freezeLeft && !hideFreeze && (
							<div>
								<div className="pre-left1" />
								<div className="pre-left2" />
								<div className="pre-left3" />
							</div>
						)}
						<button
							disabled={freezeLeft}
							className={freezeLeft ? 'btn' : 'btn btn-primary'}
							onClick={() => this.scroll(-1)}
						>
							<i className="fa fa-arrow-left" />
						</button>
					</div>
				)}
				<div ref={s => (this.scroller = s)} className="scroller">
					{children}
				</div>
				{!hide && (
					<div className="right">
						{!freezeRight && !hideFreeze && (
							<div>
								<div className="pre-right1" />
								<div className="pre-right2" />
								<div className="pre-right3" />
							</div>
						)}
						<button
							disabled={freezeRight}
							className={freezeRight ? 'btn' : 'btn btn-primary'}
							onClick={() => this.scroll(1)}
						>
							<i className="fa fa-arrow-right" />
						</button>
					</div>
				)}
			</div>
		);
	}
}

export default Scroller;
